var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2422 4.6582H11.748V0H3.25195V4.6582H1.75781C0.788498 4.6582 0 5.4467 0 6.41602V11.1621C0 12.1314 0.788498 12.9199 1.75781 12.9199H3.25195V15H11.748V12.9199H13.2422C14.2115 12.9199 15 12.1314 15 11.1621V6.41602C15 5.4467 14.2115 4.6582 13.2422 4.6582ZM4.42383 1.17188H10.5762V4.6582H4.42383V1.17188ZM4.42383 13.8281V9.93164H10.5762V13.8281H4.42383ZM13.8281 11.1621C13.8281 11.4852 13.5653 11.748 13.2422 11.748H11.748V9.93164H12.6562V8.75977H2.34375V9.93164H3.25195V11.748H1.75781C1.43475 11.748 1.17188 11.4852 1.17188 11.1621V6.41602C1.17188 6.09295 1.43475 5.83008 1.75781 5.83008H13.2422C13.5653 5.83008 13.8281 6.09295 13.8281 6.41602V11.1621ZM9.4043 2.34375V3.51562H5.5957V2.34375H9.4043Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.070379ce8314c0dd91af280fe2b0f4a3.svg";
export { ForwardRef as ReactComponent };